// extracted by mini-css-extract-plugin
module.exports = {"PostgreSqlDbDashboard":"PostgreSqlDbDashboard_d5An1"};